import React, { useState, useEffect } from "react";
import { Tooltip, } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";

import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GroupsIcon from "@mui/icons-material/Groups";
import FolderIcon from "@mui/icons-material/Folder";
import HomeIcon from "@mui/icons-material/Home";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';

const StyledTooltip = styled(props => (
  <Tooltip
    arrow
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: rgba(97, 97, 97, 0.9);
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    width: 66;
  }
`;

export default function SideMenu({
  subheader,
  items,
  href,
  icon,
  menuStatus,
  menuStatusFunc,
  subMenu,
  subMenuFunc,
}) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(subheader === menuStatus.expand);

  useEffect(() => {
    setOpen(subheader === menuStatus.expand || subMenu.menu === subheader);
  }, [subheader, menuStatus.expand, subMenu]);

  const handleClick = async () => {
    if (items.length === 0) {
      href && navigate(href);
      menuStatusFunc({ simple: subheader, expand: null });
      subMenuFunc({ menu: subheader, sub: null });
    }
    setOpen(!open);
  };

  return (
    <List
      disableRipple
      sx={{
        "& .MuiTypography-root": {
          fontSize: 16,
        },
        color: "#000",
        "& .MuiSvgIcon-root": {
          color: "#EF5658",
        },
        "& .MuiListItemIcon-root": {
          minWidth: "34px !important",
        },

        "& .MuiListItemText-primary": {
          color: "#000",
        },
        "& .MuiListItemButton-root:hover": {
          "& .MuiListItemText-primary": {
            color: "#000",
          },
          "& .MuiSvgIcon-root": {
            color: "#EF5658",
          },
          backgroundColor: menuStatus.simple ? "#fff" : "rgba(239, 86, 88, 0.1)",
          borderRadius: "4px",
          color: "#fff",
        },
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton
        sx={{
          // pl: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: menuStatus.simple ? "center" : "",
        }}
        onClick={handleClick}
        disableGutters
        disableRipple
      >
        {menuStatus.simple ? (
          <StyledTooltip title={subheader} placement="top">
            <ListItemIcon>
              <IconButton
                style={{
                  padding: menuStatus.simple === subheader ? 5 : "",
                  borderRadius: menuStatus.simple === subheader ? "100%" : "none",
                  border: menuStatus.simple === subheader ? "3px solid" : "none",
                  borderColor: menuStatus.simple === subheader ? "#0d47a1" : "none",
                }}
                onClick={async () => {
                  if (items.length === 0) {
                    menuStatusFunc({ simple: subheader, expand: null });
                    return;
                  }
                  menuStatusFunc({ simple: null, expand: subheader });
                }}
              >
                {icon === "Home" && <HomeIcon />}
                {!icon && <FolderIcon />}
                {icon === "Users" && <GroupsIcon />}
                {icon === "Report" && <ReportProblemIcon />}
                {icon === "Video" && <VideoCameraBackOutlinedIcon />}
              </IconButton>
            </ListItemIcon>
          </StyledTooltip>
        ) : (
          <ListItemIcon>
            <IconButton
              style={{
                padding: menuStatus.simple === subheader ? 5 : "",
                borderRadius: menuStatus.simple === subheader ? "100%" : "none",
                border: menuStatus.simple === subheader ? "3px solid" : "none",
                borderColor: menuStatus.simple === subheader ? "#0d47a1" : "none",
              }}
            >
              {icon === "Home" && <HomeIcon />}
              {!icon && <FolderIcon />}
              {icon === "Users" && <GroupsIcon />}
              {icon === "Report" && <ReportProblemIcon />}
              {icon === "Video" && <VideoCameraBackOutlinedIcon />}
            </IconButton>
          </ListItemIcon>
        )}

        {!menuStatus.simple && (
          <ListItemText style={{ paddingTop: 5 }} primary={subheader} />
        )}
        {items.length !== 0 && !menuStatus.simple ? (
          open ? (
            <KeyboardArrowUpIcon
              sx={{
                paddingLeft: "8px",
              }}
            />
          ) : (
            <KeyboardArrowDownIcon
              sx={{
                paddingLeft: "8px",
              }}
            />
          )
        ) : (
          ""
        )}
      </ListItemButton>
      {subheader === "Dashboard" && (
        <Divider style={{ width: "100%" /*,borderStyle: "hidden" */ }} />
      )}
      {!menuStatus.simple &&
        items.map((item, index) => (
          <Collapse in={open} autoFocus={open}>
            <List
              sx={{
                "& .MuiTypography-root": {
                  fontSize: 14,
                },
              }}
              key={`list${index}`}
              component="div"
              disablePadding
              autoFocus={open}
            >
              <ListItemButton
                disableRipple
                sx={{ pl: "50px" }}
                onClick={() => {
                  menuStatusFunc({ simple: subheader, expand: null });
                  window.scrollTo({ top: 0, behavior: 'smooth' });         
                  item.href && navigate(item.href);
                }}
              >
                {!menuStatus.simple && (
                  <ListItemText
                    primary={item.title}
                    onClick={() => item.href && navigate(item.href)}
                    style={{
                      maxWidth: "max-content",
                      minWidth: 50,
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 2,
                      borderRadius: 4,
                      color: "#EF5658 !important",
                      border:
                        subMenu.menu === subheader && subMenu.sub === item.title
                          ? "3px solid #0d47a1"
                          : "none",
                    }}
                  />
                )}
              </ListItemButton>
            </List>
          </Collapse>
        ))}
    </List>
  );
}
